import { render, staticRenderFns } from "./ProxiesManagementList.vue?vue&type=template&id=ba03bb4c&"
import script from "./ProxiesManagementList.vue?vue&type=script&lang=js&"
export * from "./ProxiesManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports